<template>
  <div>
    <nav
      class="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow"
    >
      <button
        id="sidebarToggleTop"
        class="btn btn-link d-md-none rounded-circle mr-3"
      >
        <i class="fa fa-bars"></i>
      </button>
      <ul class="navbar-nav ml-auto">
        <div class="topbar-divider d-none d-sm-block"></div>
        <li class="nav-item dropdown no-arrow">
          <a
            class="nav-link dropdown-toggle"
            id="userDropdown"
            role="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <span class="mr-2 d-none d-lg-inline text-gray-600 small">{{
              displayName
            }}</span>
            <img
              class="img-profile rounded-circle"
              src="https://bit.ly/2MKEnlW"
            />
          </a>
          <div
            class="dropdown-menu dropdown-menu-right shadow animated--grow-in"
            aria-labelledby="userDropdown"
          >
            <router-link
              :to="'/vendor/' + vendorId + '/profile'"
              class="dropdown-item"
              v-if="vendor"
            >
              <i class="fa fa-user fa-sm fa-fw mr-2 text-gray-400"></i>
              Profile
            </router-link>
            <a class="dropdown-item" href="#">
              <i class="fa fa-list fa-sm fa-fw mr-2 text-gray-400"></i>
              Activity Log
            </a>
            <div class="dropdown-divider"></div>
            <a
              class="dropdown-item"
              href="#"
              data-toggle="modal"
              @click="
                () => {
                  this.$root.logout();
                }
              "
            >
              <i class="fa fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i>
              Logout
            </a>
          </div>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      vendor: false,
      displayName: "",
      admin: false
    };
  },
  props: ["vendorId"],
  mounted() {
    this.VendorUserCheck();
  },
  methods: {
    VendorUserCheck() {
      let type = this.userRole.type;
      let access = this.userRole.permission;
      if (type == "admin") {
        this.admin = true;
      }
      if (type == "vendor" && access == "admin") {
        this.vendor = true;
      }
    }
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      userRole: "getRole"
    })
  },
  watch: {
    user() {
      this.displayName = this.user.displayName;
    }
  }
};
</script>

<style lang="scss" scoped></style>
